const getEnvironmentName = () => {
  return window.location.hostname;
};

export default getEnvironmentName;
